import * as React from "react";
const SvgInlineSprite = props => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}><defs /></svg>;
export default SvgInlineSprite;